<template>
  <eye-exam-card
    class="medical-record-exam-view"
    title="OCT Papila"
    :patient-id="patientId"
    :record-id="recordId"
    :exam-id="examId"
    :inputs="data"
    :rows-definition="table.body"
    :date="date"
    @edit="$emit('edit')"
    :show-edit-button="showEditButton"
  />
</template>

<script>
import formatters from '@/filters';
import EyeExamCard from '../ophtalmology/EyeExamCard.vue';

export default {
  name: 'OctOpticDiscView',
  components: {
    EyeExamCard,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    patientId: {
      type: String,
      required: false,
    },
    recordId: {
      type: String,
      required: false,
    },
    examId: {
      type: String,
      required: false,
    },
    date: {
      type: String,
      required: false,
    },
    showEditButton: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      table: {
        body: [
          {
            label: 'Disc. Área',
            R: 'discAreaR',
            L: 'discAreaL',
            formatter: v => formatters.millimeter(v, 2),
          },
          {
            label: 'Linear CDR',
            R: 'linearCdrR',
            L: 'linearCdrL',
            formatter: v => formatters.number(v, 2),
          },
          {
            label: 'Vertical CDR',
            R: 'verticalCdrR',
            L: 'verticalCdrL',
            formatter: v => formatters.number(v, 2),
          },
        ],
      },
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";
</style>
